var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3201 13.8267C10.4001 13.9067 10.5334 13.9067 10.6134 13.8267L12.8668 11.5734L19.6668 4.77335C19.7468 4.69335 19.7468 4.56002 19.6668 4.48002L17.5601 2.37335C17.4801 2.29335 17.3468 2.29335 17.2668 2.37335L10.4668 9.17335L7.90678 6.61335C7.82678 6.53335 7.69344 6.53335 7.61344 6.61335L5.50678 8.72002C5.42678 8.80002 5.42678 8.93335 5.50678 9.01335L8.06678 11.5734L10.3201 13.8267Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4668 16.9867L6.73344 13.2533C6.65344 13.1733 6.5201 13.1733 6.4401 13.2533L4.33344 15.36C4.25344 15.44 4.25344 15.5733 4.33344 15.6533L8.06677 19.3867L10.3201 21.64C10.4001 21.72 10.5334 21.72 10.6134 21.64L12.8668 19.3867L18.9068 13.3467C18.9868 13.2667 18.9868 13.1333 18.9068 13.0533L16.8001 10.9467C16.7201 10.8667 16.5868 10.8667 16.5068 10.9467L10.4668 16.9867Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check2.56587b1f27ac3e02598f54c446f7274b.svg";
export { ForwardRef as ReactComponent };